<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <icon-world class="animation-world" :progressValue="100"></icon-world>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img @click="$router.push('recommendation')"  class="ui-btn" src="icons/qa/ui/btnBackward.svg" />
                    </div>
                </div>
            </v-flex>
            <v-flex xs8 sm10>
                <p>Geschafft!</p>
                <p>Deine Ergebnisse lassen wir Dir per Email zukommen.</p>
                <v-form ref="emailrequestform"
                        @submit.prevent
                >
                    <v-text-field
                            v-model="mailaddress"
                            ref="inputField"
                            color="primary"
                            placeholder="Deine Email-Adresse"
                            @keyup.enter="handleKeyUpEnterInInputField"
                    ></v-text-field>
                </v-form>
            </v-flex>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img @click="sendRecommendation"  class="ui-btn" src="icons/qa/ui/btnForward.svg" />
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <v-dialog
                v-model="sendDataRunning"
                persistent
                width="300"
        >
            <v-card

            >
                <v-card-text>
                    Versand an {{ mailaddress }} läuft ...
                    <v-progress-linear
                            indeterminate
                            color="primary"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="sendDataSuccess"
                persistent
                width="300"
        >
            <v-card
            >
                <v-card-text>
                    Die Email wurde erfolgreich an {{ mailaddress }} versendet.
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click="sendDataSuccess=false;$router.push('mailconfirmation');">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="sendDataError"
                width="300"
        >
            <v-card
            >
                <v-card-text>
                    Der Versand der Email an {{ mailaddress }} war leider <strong>nicht erfolgreich</strong>!<br>
                    Bitte prüfe die Mailadresse und versuche es ggf. erneut.
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click="sendDataError=false">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import MailService from '../Services/MailService';
    import IconWorld from "./IconWorld";

    export default {
        name: "MailRequest",
        data(){
            return {
                allActive: true,
                sendDataRunning: false,
                sendDataSuccess: false,
                sendDataError: false
            }
        },
        components: {IconWorld},
        computed: {
            mailaddress: {
                get(){
                    return this.$store.getters['qa/getUserEmail'];
                },
                set(value){
                    this.$store.commit('qa/SET_USER_EMAIL',value);
                }
            },
            userName() {
                return this.$store.getters['qa/getUserName'];
            }
        },
        mounted(){
            this.$refs.inputField.focus();
        },
        methods:{
            backToRecommendation(){
                this.$router.push('recommendation');
            },
            handleKeyUpEnterInInputField(){
                // Service-Aufruf für den Mailversand
                // ....
                this.sendRecommendation();
            },
            extractIconDataFromDom(){
                let imgArray = document.querySelectorAll('.v-progress-circular__info img');
                let iconDataArray = [];
                let tmpStyle = {};
                for(let i=0; i < imgArray.length; i++){
                    tmpStyle = getComputedStyle(imgArray[i]);
                    if(tmpStyle.opacity=='1'){
                        iconDataArray.push({ 'src': imgArray[i].src, 'x': tmpStyle.left, 'y': tmpStyle.top});
                    }
                }
                this.$store.dispatch('qa/setIcons4pdf',iconDataArray);
                // console.dir(iconDataArray);
            },
            sendRecommendation(){
                this.extractIconDataFromDom();
                // return;
                let self = this;
                this.sendDataRunning = true;
                MailService.sendRecommendationToCustomer(self.$store.state.qa)
                    .then(function (response) {
                        self.sendDataRunning = false;
                        self.sendDataSuccess = true;
                    }).catch(function (response) {
                    self.sendDataRunning = false;
                    self.sendDataError = true;
                });
            },
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 599px) {
        .v-input:not(.v-input--radio-group):not(.v-input--checkbox):not(.v-input--switch){
            width: 100%;
        }
    }

</style>
